import { render, staticRenderFns } from "./serveReturnSecond.vue?vue&type=template&id=1abc0350&scoped=true&"
import script from "./serveReturnSecond.vue?vue&type=script&lang=js&"
export * from "./serveReturnSecond.vue?vue&type=script&lang=js&"
import style0 from "./serveReturnSecond.vue?vue&type=style&index=0&id=1abc0350&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abc0350",
  null
  
)

export default component.exports